/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ZonedDateTime: { input: any; output: any; }
};

export type AdaType = {
  __typename?: 'AdaType';
  description?: Maybe<Scalars['String']['output']>;
  id: Array<Maybe<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AuthorizationOffInput = {
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  creditCardType?: InputMaybe<Scalars['String']['input']>;
  holderName?: InputMaybe<Scalars['String']['input']>;
};

export type CardDetail = {
  __typename?: 'CardDetail';
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CardDetailsInput = {
  /** defaults to true */
  authNumber?: InputMaybe<Scalars['String']['input']>;
  autoAuthorizeCard?: InputMaybe<Scalars['Boolean']['input']>;
  certificateId?: InputMaybe<Scalars['String']['input']>;
  creditCardBin?: InputMaybe<Scalars['String']['input']>;
  creditCardHash?: InputMaybe<Scalars['String']['input']>;
  creditCardMask?: InputMaybe<Scalars['String']['input']>;
  creditCardNumber?: InputMaybe<Scalars['String']['input']>;
  creditCardType?: InputMaybe<Scalars['String']['input']>;
  emv?: InputMaybe<EmvInput>;
  expiration?: InputMaybe<MonthYear>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type Cart = {
  __typename?: 'Cart';
  eventFees?: Maybe<Array<Maybe<CartEventFee>>>;
  id: Scalars['ID']['output'];
  /** deprecated, use identifier */
  identifier?: Maybe<Identifier>;
  items?: Maybe<Array<Maybe<CartItem>>>;
  totals?: Maybe<Pricing>;
};

export type CartEventFee = {
  __typename?: 'CartEventFee';
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type CartEventFeesInput = {
  cartIdentifier: IdentifierInput;
  eventCode?: InputMaybe<Scalars['String']['input']>;
  eventFees: Array<EventFeeInput>;
  eventId?: InputMaybe<Scalars['String']['input']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  /** deprecated, really needed? why? */
  eventCode?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** deprecated, really needed? why? */
  places?: Maybe<Array<Maybe<PlaceReservation>>>;
};

export type Charge = {
  __typename?: 'Charge';
  amount: Price;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type ChargeInput = {
  amount?: InputMaybe<PriceInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckoutPayment = {
  amount: PriceInput;
  cardDetails?: InputMaybe<CardDetailsInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<DeliveryPaymentMethod>;
  otherMOPDetails?: InputMaybe<OtherMopDetailsInput>;
};

export type CreditCardInput = {
  authorizationOff?: InputMaybe<AuthorizationOffInput>;
  pdg?: InputMaybe<PdgInput>;
  provider: CreditCardProvider;
  tmds?: InputMaybe<TmdsInput>;
  token?: InputMaybe<PaymentTokenInput>;
};

export enum CreditCardProvider {
  AuthorizationOff = 'AUTHORIZATION_OFF',
  Pdg = 'PDG',
  Tmds = 'TMDS',
  Token = 'TOKEN'
}

export type CustomerAddress = {
  country?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerFullName = {
  first?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerInfo = {
  address?: InputMaybe<CustomerAddress>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<CustomerFullName>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
};

export enum DeliveryMethod {
  Email = 'EMAIL',
  Print = 'PRINT',
  Sms = 'SMS'
}

export type DeliveryPaymentMethod = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryReceiptInput = {
  method: DeliveryMethod;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type DeliveryRequest = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<CustomerInfo>;
  eventDate?: InputMaybe<Scalars['String']['input']>;
  /** (AAPI only) Account ID - Identifier specific to one customer containing past and current ticket history */
  eventId?: InputMaybe<Scalars['String']['input']>;
  identifier: IdentifierInput;
  method: DeliveryMethod;
  orderCreationDate?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  orderItems?: InputMaybe<Array<InputMaybe<OrderItem>>>;
  paymentReference?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<Array<InputMaybe<CheckoutPayment>>>;
  /** AAPI only, Host resolves through EDB */
  print?: InputMaybe<PrintDetails>;
  recipient?: InputMaybe<Scalars['String']['input']>;
  refund?: InputMaybe<Scalars['Boolean']['input']>;
  totals: PricingInput;
  /** (Host only) Required by presto for receipt delivery */
  venue?: InputMaybe<VenueInput>;
};

export type DeliveryTicketInput = {
  method: DeliveryMethod;
  recipient?: InputMaybe<Scalars['String']['input']>;
};

export type EmvInput = {
  applicationIdentifier?: InputMaybe<Scalars['String']['input']>;
  approvalCode?: InputMaybe<Scalars['String']['input']>;
  approvalResult?: InputMaybe<Scalars['String']['input']>;
  cardEntryMode?: InputMaybe<Scalars['String']['input']>;
  cardholderFullName?: InputMaybe<Scalars['String']['input']>;
  hostToken?: InputMaybe<Scalars['String']['input']>;
  paymentReference?: InputMaybe<Scalars['String']['input']>;
  /** Arx only */
  terminalId?: InputMaybe<Scalars['String']['input']>;
  terminalVerificationResult?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
  transactionType?: InputMaybe<Scalars['String']['input']>;
};

export type Event = {
  __typename?: 'Event';
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventCode?: Maybe<Scalars['String']['output']>;
  hostName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
  rotatingEntryTokenEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type EventFee = {
  __typename?: 'EventFee';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  maxQuantity?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Price>;
};

export type EventFeeInput = {
  id: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type FindBestAvailableInput = {
  priceLevels: Array<InputMaybe<Scalars['String']['input']>>;
  quantity: Scalars['Int']['input'];
};

export type Identifier = {
  __typename?: 'Identifier';
  id: Scalars['String']['output'];
  subSystem: Scalars['String']['output'];
  system: Scalars['String']['output'];
};

export type IdentifierInput = {
  id: Scalars['String']['input'];
  subSystem?: InputMaybe<Scalars['String']['input']>;
  system: Scalars['String']['input'];
};

export type Location = {
  __typename?: 'Location';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  venue?: Maybe<Venue>;
};

export enum MarketTypeId {
  Primary = 'PRIMARY',
  Retail = 'RETAIL',
  Secondary = 'SECONDARY'
}

/** move to common */
export type MonthYear = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  cancelOrderPayment?: Maybe<Scalars['Boolean']['output']>;
  cancelPayment?: Maybe<Scalars['String']['output']>;
  deleteCart?: Maybe<Scalars['Boolean']['output']>;
  deliver?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  payOrder?: Maybe<PayOrderMutationResult>;
  purchase?: Maybe<PurchaseResult>;
  redeliver?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  removeFromCart?: Maybe<ReserveResult>;
  reserve?: Maybe<ReserveResult>;
  retryPayment?: Maybe<PaymentResult>;
  setCartEventFees?: Maybe<Cart>;
  startPayment?: Maybe<Scalars['String']['output']>;
};


export type MutationCancelOrderPaymentArgs = {
  orderId: IdentifierInput;
};


export type MutationCancelPaymentArgs = {
  paymentReference?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteCartArgs = {
  cartId: IdentifierInput;
};


export type MutationDeliverArgs = {
  request: DeliveryRequest;
};


export type MutationPayOrderArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  delivery?: InputMaybe<PayOrderDeliveryInput>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<IdentifierInput>;
  manualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  orderId?: InputMaybe<IdentifierInput>;
};


export type MutationPurchaseArgs = {
  cartId: IdentifierInput;
  customer: CustomerInput;
  linkGlobalAccount: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  payment: PaymentInput;
};


export type MutationRedeliverArgs = {
  request: RedeliveryRequest;
};


export type MutationRemoveFromCartArgs = {
  cartId: IdentifierInput;
  cartItemId: Scalars['ID']['input'];
};


export type MutationReserveArgs = {
  cartId?: InputMaybe<IdentifierInput>;
  eventId?: InputMaybe<Array<InputMaybe<IdentifierInput>>>;
  findBestAvailable?: InputMaybe<FindBestAvailableInput>;
  inventoryId: Scalars['ID']['input'];
  offerId: Scalars['ID']['input'];
  seat?: InputMaybe<ReserveSeatInput>;
};


export type MutationRetryPaymentArgs = {
  orderId: IdentifierInput;
  payment: PaymentInput;
};


export type MutationSetCartEventFeesArgs = {
  input: CartEventFeesInput;
};


export type MutationStartPaymentArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  eventCode?: InputMaybe<Scalars['String']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  hostId?: InputMaybe<Scalars['String']['input']>;
  manualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  opCode?: InputMaybe<Scalars['String']['input']>;
  qrCodeProvider?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCreated = {
  __typename?: 'OrderCreated';
  orderId: Scalars['String']['output'];
};

export type OrderCreating = {
  __typename?: 'OrderCreating';
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type OrderItem = {
  generalAdmission?: InputMaybe<Scalars['Boolean']['input']>;
  row?: InputMaybe<Scalars['String']['input']>;
  seat?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  ticketTypeId?: InputMaybe<Scalars['ID']['input']>;
  ticketTypeLabel?: InputMaybe<Scalars['String']['input']>;
};

export type OrderPaymentState = {
  __typename?: 'OrderPaymentState';
  deliveryErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  errorCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderPaymentStatus>;
  ticketsAndReceipts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum OrderPaymentStatus {
  Canceled = 'CANCELED',
  Canceling = 'CANCELING',
  Delivering = 'DELIVERING',
  Done = 'DONE',
  Error = 'ERROR',
  Paying = 'PAYING',
  Processing = 'PROCESSING'
}

export type OrderWithAccountCreated = {
  __typename?: 'OrderWithAccountCreated';
  accountId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
};

export type OtherInput = {
  category?: InputMaybe<PaymentCategory>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type OtherMopDetailsInput = {
  autoAuthorize?: InputMaybe<Scalars['Boolean']['input']>;
  expiration?: InputMaybe<MonthYear>;
  paymentInfo?: InputMaybe<Scalars['String']['input']>;
};

export type PdgInput = {
  paymentReference?: InputMaybe<Scalars['String']['input']>;
};

export type PayOrderDeliveryInput = {
  printer?: InputMaybe<PrinterDetails>;
  receipt?: InputMaybe<DeliveryReceiptInput>;
  ticket?: InputMaybe<DeliveryTicketInput>;
};

export type PayOrderMutationResult = {
  __typename?: 'PayOrderMutationResult';
  error?: Maybe<Scalars['String']['output']>;
  started?: Maybe<Scalars['Boolean']['output']>;
};

export enum PaymentCategory {
  Csh = 'CSH',
  Oca = 'OCA',
  Occ = 'OCC',
  Och = 'OCH',
  Onc = 'ONC',
  Unknown = 'UNKNOWN'
}

export type PaymentDevice = {
  __typename?: 'PaymentDevice';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PaymentInput = {
  amount: Scalars['Float']['input'];
  creditCard?: InputMaybe<CreditCardInput>;
  method: PaymentMethod;
  other?: InputMaybe<OtherInput>;
};

export enum PaymentMethod {
  CreditCard = 'CREDIT_CARD',
  Other = 'OTHER'
}

export type PaymentResult = {
  __typename?: 'PaymentResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  card?: Maybe<CardDetail>;
  transaction?: Maybe<Transaction>;
};

export type PaymentTokenInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  holderName?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PhoneInput = {
  number: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

export type PlacePricing = {
  __typename?: 'PlacePricing';
  faceValue?: Maybe<Price>;
  fees?: Maybe<Price>;
  feesAndTaxes?: Maybe<Price>;
  feesAndTaxesBreakdown?: Maybe<Array<Maybe<Charge>>>;
  taxes?: Maybe<Price>;
  total?: Maybe<Price>;
};

export type PlaceReservation = {
  __typename?: 'PlaceReservation';
  adaType?: Maybe<Scalars['String']['output']>;
  generalAdmission?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['ID']['output']>;
  pricing?: Maybe<PlacePricing>;
  row?: Maybe<Scalars['String']['output']>;
  /** deprecated, use seat */
  seat?: Maybe<Scalars['String']['output']>;
  /** deprecated, really needed? why? */
  section?: Maybe<Scalars['String']['output']>;
  ticketType: Scalars['ID']['output'];
};

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type PriceInput = {
  amount: Scalars['Float']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type PriceLevelGroup = {
  __typename?: 'PriceLevelGroup';
  id?: Maybe<Scalars['ID']['output']>;
  priceLevelIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Pricing = {
  __typename?: 'Pricing';
  eventFees?: Maybe<Price>;
  eventFeesBreakdown?: Maybe<Array<Maybe<Charge>>>;
  faceValue?: Maybe<Price>;
  fees?: Maybe<Price>;
  feesAndTaxes?: Maybe<Price>;
  feesAndTaxesBreakdown?: Maybe<Array<Maybe<Charge>>>;
  taxes?: Maybe<Price>;
  total?: Maybe<Price>;
};

export type PricingInput = {
  eventFees?: InputMaybe<PriceInput>;
  eventFeesBreakdown?: InputMaybe<Array<InputMaybe<ChargeInput>>>;
  faceValue?: InputMaybe<PriceInput>;
  fees?: InputMaybe<PriceInput>;
  feesAndTaxes?: InputMaybe<PriceInput>;
  feesAndTaxesBreakdown?: InputMaybe<Array<InputMaybe<ChargeInput>>>;
  taxes?: InputMaybe<PriceInput>;
  total?: InputMaybe<PriceInput>;
};

export type PrintDetails = {
  dpi?: InputMaybe<PrintingDpi>;
  method?: InputMaybe<PrintingMethod>;
  receiptQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type PrintableTestTicketRequest = {
  printingDpi?: InputMaybe<PrintingDpi>;
  printingMethod: PrintingMethod;
};

export type PrinterDetails = {
  dpi?: InputMaybe<PrintingDpi>;
  method?: InputMaybe<PrintingMethod>;
};

export enum PrintingDpi {
  Dpi200 = 'DPI200',
  Dpi300 = 'DPI300'
}

export enum PrintingMethod {
  Boca = 'BOCA',
  Pdf = 'PDF',
  Png = 'PNG',
  Postscript = 'POSTSCRIPT'
}

export type PurchaseFailed = {
  __typename?: 'PurchaseFailed';
  errorCode: Scalars['String']['output'];
};

export type PurchaseResult = OrderCreated | OrderCreating | OrderWithAccountCreated | PurchaseFailed | RecoverablePurchaseFailed;

export type Query = {
  __typename?: 'Query';
  adaTypes?: Maybe<Array<Maybe<AdaType>>>;
  event?: Maybe<Event>;
  eventFees?: Maybe<Array<Maybe<EventFee>>>;
  paymentDevices?: Maybe<Array<Maybe<PaymentDevice>>>;
  paymentState: OrderPaymentState;
  paymentStatus?: Maybe<PaymentStatus>;
  priceLevelGroups?: Maybe<Array<Maybe<PriceLevelGroup>>>;
  printableTestTicket?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sellClasses?: Maybe<Array<Maybe<SellClass>>>;
  ticketTypes?: Maybe<Array<Maybe<TicketType>>>;
};


export type QueryAdaTypesArgs = {
  eventId: IdentifierInput;
};


export type QueryEventArgs = {
  eventId?: InputMaybe<IdentifierInput>;
};


export type QueryEventFeesArgs = {
  eventId?: InputMaybe<IdentifierInput>;
};


export type QueryPaymentStateArgs = {
  orderId: IdentifierInput;
};


export type QueryPaymentStatusArgs = {
  paymentReference: Scalars['String']['input'];
};


export type QueryPriceLevelGroupsArgs = {
  eventId?: InputMaybe<IdentifierInput>;
};


export type QueryPrintableTestTicketArgs = {
  printableTestTicketRequest?: InputMaybe<PrintableTestTicketRequest>;
};


export type QuerySellClassesArgs = {
  eventId?: InputMaybe<IdentifierInput>;
};


export type QueryTicketTypesArgs = {
  eventId?: InputMaybe<IdentifierInput>;
  feeEquivalenceClassId?: InputMaybe<IdentifierInput>;
};

export type Rate = {
  __typename?: 'Rate';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Price>;
  priceLevels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RecoverablePurchaseFailed = {
  __typename?: 'RecoverablePurchaseFailed';
  errorCode: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  recoveryAction?: Maybe<Scalars['String']['output']>;
};

export type RedeliveryRequest = {
  customer?: InputMaybe<CustomerInfo>;
  deliveryMethod: DeliveryMethod;
  eventCode: Scalars['String']['input'];
  /** Event code on host, or event name on Archtics */
  eventId?: InputMaybe<Scalars['String']['input']>;
  identifier: IdentifierInput;
  /** (Host Only) */
  marketType?: InputMaybe<MarketTypeId>;
  orderCreationDate?: InputMaybe<Scalars['ZonedDateTime']['input']>;
  /** (Host Only) */
  orderCurrency?: InputMaybe<Scalars['String']['input']>;
  /** (Archtics Only) */
  print?: InputMaybe<PrintDetails>;
  /** (Archtics Only) Event ID */
  recipient?: InputMaybe<Scalars['String']['input']>;
  /** (Host Only) */
  seatBlocks?: InputMaybe<Array<InputMaybe<SeatBlock>>>;
};

export type ReserveFailed = {
  __typename?: 'ReserveFailed';
  error?: Maybe<Scalars['String']['output']>;
};

export type ReservePending = {
  __typename?: 'ReservePending';
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type ReserveResult = Cart | ReserveFailed | ReservePending;

export type ReserveSeatInput = {
  adaType?: InputMaybe<Scalars['String']['input']>;
  row: Scalars['String']['input'];
  seat: Scalars['String']['input'];
  section: Scalars['String']['input'];
};

export type Row = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SeatBlock = {
  eventCode?: InputMaybe<Scalars['String']['input']>;
  generalAdmission?: InputMaybe<Scalars['Boolean']['input']>;
  row?: InputMaybe<Row>;
  seats?: InputMaybe<Seats>;
  section?: InputMaybe<Section>;
  xrsCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Seats = {
  count?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  num?: InputMaybe<Scalars['String']['input']>;
};

export type Section = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SellClass = {
  __typename?: 'SellClass';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TmdsInput = {
  bin?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  expirationMonth?: InputMaybe<Scalars['String']['input']>;
  expirationYear?: InputMaybe<Scalars['String']['input']>;
  hostToken?: InputMaybe<Scalars['String']['input']>;
  lastFourDigits?: InputMaybe<Scalars['String']['input']>;
  merchantReceiptData?: InputMaybe<Scalars['String']['input']>;
  nameOnCard?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type TicketType = {
  __typename?: 'TicketType';
  expandedMaskLevel2?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inventoryExclusive?: Maybe<Scalars['Boolean']['output']>;
  inventoryOfferSetId?: Maybe<Scalars['String']['output']>;
  maxPrice?: Maybe<Price>;
  minPrice?: Maybe<Price>;
  name?: Maybe<Scalars['String']['output']>;
  promoCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rates?: Maybe<Array<Maybe<Rate>>>;
};

export type Transaction = {
  __typename?: 'Transaction';
  error?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Venue = {
  __typename?: 'Venue';
  id?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type VenueInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PurchaseMutationVariables = Exact<{
  cartId: IdentifierInput;
  customer: CustomerInput;
  payment: PaymentInput;
  note: Scalars['String']['input'];
  linkGlobalAccount: Scalars['Boolean']['input'];
}>;


export type PurchaseMutation = { __typename?: 'Mutation', purchase?: { __typename: 'OrderCreated' } | { __typename: 'OrderCreating' } | { __typename: 'OrderWithAccountCreated', orderId: string, accountId: string } | { __typename: 'PurchaseFailed', errorCode: string } | { __typename: 'RecoverablePurchaseFailed' } | null };


export const PurchaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"purchase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IdentifierInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"payment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkGlobalAccount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cartId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cartId"}}},{"kind":"Argument","name":{"kind":"Name","value":"customer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer"}}},{"kind":"Argument","name":{"kind":"Name","value":"payment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"payment"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}},{"kind":"Argument","name":{"kind":"Name","value":"linkGlobalAccount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkGlobalAccount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWithAccountCreated"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"accountId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseFailed"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorCode"}}]}}]}}]}}]} as unknown as DocumentNode<PurchaseMutation, PurchaseMutationVariables>;